import { useCallback } from 'react';
import styled from 'styled-components';
import { Modal } from '@salecycle/ui-component-library';
import { useAllowListModal } from '../../tabs/CampaignWorkflowTab/contexts';
import { IPWhitelistModal } from '../../tabs/CampaignSettingsTab/components/IPWhitelistModal';
import { useTranslation } from 'react-i18next';
import { useMoveToStatus } from '../../hooks/useMoveToStatus';
import { useCampaignSettings } from '../../tabs/CampaignWorkflowTab/state/CampaignSettings/hooks/useCampaignSettings';
import { OnsiteCampaignStatus } from 'sections/onsite-campaigns/types';

const ModalContainer = styled.div`
  display: block;
`;

export interface AddIpAddressWarningModalProps {
  open: boolean;
  onClose: () => void;
}

export const AddIpAddressWarningModal = ({ open, onClose }: AddIpAddressWarningModalProps) => {
  const { t } = useTranslation('campaigns');
  const { openAllowListModal, closeAllowListModal, allowListModalOpen } = useAllowListModal();
  const { allowList } = useCampaignSettings();
  const moveToStatus = useMoveToStatus();
  const { status: campaignStatus, setStatus } = useCampaignSettings();

  const revertToDraft = useCallback(() => {
    setStatus('Draft');
    moveToStatus(OnsiteCampaignStatus.DRAFT);
  }, [moveToStatus, setStatus]);

  const onCloseWithoutAddingIp = useCallback(() => {
    if (campaignStatus === 'Test') {
      revertToDraft();
    }

    onClose();
  }, [campaignStatus, onClose, revertToDraft]);

  const onCloseWithAddIp = useCallback(() => {
    onClose();

    if (!allowList?.length) {
      openAllowListModal();
    }
  }, [allowList?.length, onClose, openAllowListModal]);

  return (
    <>
      <Modal
        minWidth={570}
        heading={t('onsite.editor.workflow.addIpAddressWarningModal.heading')}
        isOpen={open}
        variation="clean"
        onCloseButtonClicked={onClose}
        onCancelButtonClicked={onCloseWithAddIp}
        cancelButtonType={'primary'}
        cancelButtonLabel={t('onsite.editor.workflow.addIpAddressWarningModal.confirmButton')}
        cancelButtonAriaLabel={t('onsite.editor.workflow.addIpAddressWarningModal.confirmButtonAria')}
        onOkButtonClicked={onCloseWithoutAddingIp}
        okButtonLabel={t('onsite.editor.workflow.addIpAddressWarningModal.closeButton')}
        okButtonAriaLabel={t('onsite.editor.workflow.addIpAddressWarningModal.closeButtonAria')}
        okButtonType={'secondary'}
      >
        <ModalContainer>
          <div>{t('onsite.editor.workflow.addIpAddressWarningModal.body')}</div>
        </ModalContainer>
      </Modal>

      <IPWhitelistModal
        open={allowListModalOpen}
        onCloseButtonClicked={closeAllowListModal}
        onOkButtonClicked={closeAllowListModal}
      />
    </>
  );
};
